var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-white flex flex-col h-16- flex-grow",class:[_vm.$device.isMobile && _vm.selections && _vm.selections.length < 2?'h-full': 'h-16 ']},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }